import * as React from "react";
import {Root, Indicator} from "@radix-ui/react-progress";

const Progress = ({height = 6}) => {
    const [progress, setProgress] = React.useState(10);

    React.useEffect(() => {
        const timer = setTimeout(() => setProgress(50), 500);
        const timer2 = setTimeout(() => setProgress(100), 1500);
        return () => {
            clearTimeout(timer);
            clearTimeout(timer2)
        }
    }, []);

    return (
        <Root
            className="relative overflow-hidden rounded-full bg-slate-200"
            style={{ transform: "translateZ(0)", height }}
            value={progress}
        >
            <Indicator
                className="h-[inherit] ease-[cubic-bezier(0.65, 0, 0.35, 1)] size-full bg-slate-950 transition-transform duration-[660ms]"
                style={{ transform: `translateX(-${100 - progress}%)` }}
            />
        </Root>
    );
};

export default Progress;
